export default (theme) => ({
  container: {
    width: "100%",
    height: "100%",
    position: "relative",
    zIndex: 999,
  },
});
